import React from 'react';
import { Typography, Grid, Box} from "@material-ui/core";
import { globalStyles } from "../../style/GlobalStyles";
import { SectionSubTitle } from '../../components/SectionSubTitle';

export default function HelpSchedaBudgetProfessionista(props: any) {
    const gClasses = globalStyles();
    return (
        <Grid container spacing={3} justify="flex-start" alignItems="flex-start" direction="column" style={{ margin: "1rem", width: "90vw"}}>
            <SectionSubTitle text="IRAP"></SectionSubTitle>
            <Typography>
                L'imposta dovuta è di norma pari al 3,90% del valore della produzione netta. Alcune Regioni hanno però fissato una diversa aliquota,
                selezionabile dall'operatore.
                Il processo di determinazione di detto valore, può essere sommariamente rappresentato , avendo riguardo al presente schema di CONTO ECONOMICO TIPO, dalla formula:
                <Box fontWeight="fontWeightMedium">
                    Risultato netto + Interessi passivi + Spese per i dipendenti.
                </Box>
                L'operatore deve indicare l'ammontare presunto delle deduzioni.
                </Typography>
            <SectionSubTitle text="IRPEF"></SectionSubTitle>
            <Typography>
                Il reddito imponibile, è determinato avendo riguardo al reddito di lavoro autonomo:
                <Box fontWeight="fontWeightMedium">reddito netto nello schema di CONTO ECONOMICO TIPO</Box>,
                diminuito dei contributi previdenziali calcolati.
                Sul reddito imponibile così calcolato, è determinata l'imposta lorda, con le aliquote e gli scaglioni di reddito vigenti.
                L'imposta netta è determinata sottraendo dall'imposta lorda:
                <Box fontWeight="fontWeightMedium">- la detrazione per familiari (coniuge e figli) a carico calcolata avendo riguardo alle indicazioni relative ai carichi familiari, nella misura effettivamente spettante. 
                Con l'introduzione dell'Assegno Unico Universale, la detrazione per i figli a carico può essere richiesta solo per i figli di età pari o superiore a 21 anni.
                </Box>
                <Box fontWeight="fontWeightMedium">- la detrazione per redditi di lavoro autonomo nella misura effettivamente spettante.</Box>
                <Box className={gClasses.box}>
                Sono stimate le addizionali Regionale e Comunale all'IRPEF, nella misura complessiva forfetaria del 2,5%.
                Si tenga in ogni caso presente che il risultato del calcolo, non tiene ovviamente conto dell'eventuale possesso, da parte del soggetto, di ulteriori redditi, di ulteriori oneri deducibili o detrazioni d'imposta, che potrebbero modificare anche sensibilmente l'ammontare dell'IRPEF.
                </Box>
            </Typography>
            <SectionSubTitle text="GESTIONE SEPARATA INPS"></SectionSubTitle>
            <Typography>
                La base imponibile per il calcolo dei contributi è rappresentata dal reddito di lavoro autonomo determinato ai fini fiscali.
                I contributi previdenziali sono diversamente calcolati secondo la situazione previdenziale del soggetto.
                Le aliquote, gli scaglioni e i massimali utilizzati sono quelli vigenti.
                </Typography>
            <SectionSubTitle text="CASSA AUTONOMA"></SectionSubTitle>
            <Typography>
                Per i professionisti iscritti alla relativa cassa previdenziale, nel foglio "DATI PER IMPOSTE E CONTR." sarà possibile inserire l'ammontare dei contributi dovuti, previo calcolo da effettuarsi a cura dell'operatore.
                </Typography>
        </Grid>)
}